import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import { format } from "date-fns"; // Import date-fns format function
import { CheckBadgeIcon, CheckCircleIcon, ClockIcon, Cog6ToothIcon, ExclamationCircleIcon, ExclamationTriangleIcon, XCircleIcon } from "@heroicons/react/20/solid";
import { over } from "lodash";

export default function Bids() {
  const navigate = useNavigate();
  const user = useContext(AuthContext);
  const [bids, setBids] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [amendedHours, setAmendedHours] = useState(1);
  const [overallBids, setOverallBids] = useState([]);
  


  console.log(amendedHours)


  useEffect(() => {
    fetchBids();

    // Fetch bids every 2 minutes
    const interval = setInterval(fetchBids, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchBids = async () => {
    const response = await fetch("https://api.insightos.co.uk/api/bids", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: 'include',

    });

    if (!response.ok) throw new Error("Failed to fetch bids");

    const data = await response.json();

console.log(data.data);


console.log(user)

// only allow through bids where Accepted is 0

const response2 = await fetch("https://api.insightos.co.uk/api/bidstats", {
  method: "GET",
  headers: {
    "Content-Type": "application/json",
  },
  credentials: 'include',

});

if (!response2.ok) throw new Error("Failed to fetch bid stats");

const data2 = await response2.json();

console.log(data2.data);


setOverallBids(data2.data);

    




    setBids(data.data);
  };

  // Use date-fns to format the date
  const formatDate = (timestamp) => {
    return format(new Date(timestamp), "dd-MM-yyyy HH:mm");
  };

  const formatJustDate = (timestamp) => {
    return format(new Date(timestamp), "EEEE do MMMM yyyy");
};


  const handleAccept = async (id, overtimeId, staffName ) => {

    try {
      const response = await fetch('https://api.insightos.co.uk/api/acceptbid', {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',

        body: JSON.stringify({ id, overtimeId, staffName }),
      });

      if (!response.ok) throw new Error("Failed to accept bid");

      // Refresh the bids after accepting
      fetchBids();
    } catch (error) {
      console.error(error);
    }
  };

  const handleCloseAuction = async (overtimeId) => {

    try {

      const response = await fetch('https://api.insightos.co.uk/api/closeauction', {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',


        body: JSON.stringify({ overtimeId }),

      });

      if (!response.ok) throw new Error("Failed to close auction");

      // Refresh the bids after accepting

      fetchBids();

    } catch (error) {
      console.error(error);
    }

  };





  const handleAmend = (bidId) => {
    setOpenModal(true);
  };

  const handleSaveAmendment = async (id,  overtimeId) => {

    try {
      const response = await fetch('https://api.insightos.co.uk/api/amendbid', {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',

        body: JSON.stringify({ id, Hours: amendedHours, overtimeId }),
      });

      if (!response.ok) throw new Error("Failed to accept bid");

      // Refresh the bids after accepting
      fetchBids();
    } catch (error) {
      console.error(error);
    }

  };



  

  if (bids.length === 0) {
    return <div className="flex justify-center items-center h-screen">
        <Cog6ToothIcon className="w-12 h-12 mr-1 text-white animate-spin" />
        <p className="text-white text-2xl">No Bids Pending</p>
    </div>
    
    
  }
  
  return (
    <div
      className="min-h-screen bg-cover bg-center bg-gradient-to-t from-indigo-500 from-10% via-sky-500 via-30% to-emerald-500 to-90%"
     
    >
      <div className="p-6">
        <div className="space-y-4">
          {bids.length === 0 && (
            <p className="text-white text-2xl">No Bids Pending</p>
          )}

<div className="overflow-x-auto w-full scrollbar-hide">
  <div className="flex space-x-4 snap-x snap-mandatory overflow-x-scroll pb-4 scrollbar-hide">
    {Object.entries(overallBids).map(([name, stats]) => {
      const acceptancePercentage = stats.bidsMade > 0 
        ? ((stats.bidsAccepted / stats.bidsMade) * 100).toFixed(1) + "%" 
        : "0%";

      return (
        <div 
          key={name} 
          className="bg-white shadow-md rounded-lg p-4 border min-w-[300px] snap-center"
        >
          <h3 className="text-md font-semibold mb-2">{name}</h3>
          <p className="text-gray-700 text-sm">
            <strong>Bids/Accepted:</strong> {stats.bidsMade}/{stats.bidsAccepted} 
            <span className="text-green-600 ml-2">({acceptancePercentage})</span>
          </p>
          <p className="text-gray-700 text-sm">
            <strong>Rejected:</strong> {stats.overtimeRejected}
          </p>
        </div>
      );
    })}
  </div>
</div>




          {bids
            .map((overtime) => (
              <div
                key={overtime.id}
                className="flex flex-col space-y-4 p-6 shadow-lg rounded-lg bg-opacity-50 backdrop-blur-sm"
              >
                {/* Overtime Title Card */}
                <div className="flex justify-between items-center border-b pb-4">
                  <div>
                    <p className="font-medium text-lg text-white">{overtime.Role}</p>
                    <p className="text-lg text-white">{formatJustDate(overtime.OvertimeDate)}</p>
                    <p className="text-lg text-yellow-300 mt-3 text-bold p-1 bg-blue-900 rounded-lg inline-block">
                      Allocated: {overtime.Hours} {overtime.Hours === 1 ? "Hour" : "Hours"}
                    </p>
                    <div className="flex justify-between space-x-2 mt-5">


                      {overtime.bids.length > 0 && (
    <button onClick={() => handleCloseAuction(overtime.id)}
    data-component="bids-overtime-action"
    data-feature="close_auction_put"

    className="bg-white text-black px-3 py-1 rounded-full hover:bg-emerald-300 text-xs">
      Close Auction 
    </button>
  )}
  {overtime.bids.length === 0 && (
    <button className="bg-red-500 text-white px-3 py-1 rounded-full hover:bg-red-600 text-xs">
      No Bids - Cancel Overtime
    </button>
  )}
  <button className="bg-red-500 text-white px-3 py-1 rounded-full hover:bg-yellow-600 text-xs">
    Emergency Cancel 
  </button>




    </div>
                  </div>
                  <div className="flex items-center space-x-1">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-yellow-300 text-blue-900 font-bold text-lg">
                      {overtime.bids.length}
                    </div>
                    <p className="ml-2 text-lg text-white">{overtime.bids.length === 1 ? "Bid" : "Bids"}</p>
                  </div>
                </div>

{overtime.staffWithStatus.map((staff) => (
  <div key={staff.Name} className="flex justify-between items-center overflow-x-auto">
    <div className="flex items-center space-x-2">
      {staff.Status === 0 ? (
        <XCircleIcon className="w-8 h-8 text-red-500" />
      ) : staff.Status === 1 ? (
        <ClockIcon className="w-8 h-8 text-yellow-300 animate-pulse" />
      ) : staff.Status === 2 ? (
        <ExclamationTriangleIcon className="w-8 h-8 text-yellow-500" />
      ) : staff.Status === 3 ? (
        <div className="flex items-center space-x-1">
        <CheckCircleIcon className="w-8 h-8 text-emerald-100" />
        <p className="text-white">  {staff.Hours} Hour Approved : </p>
        </div>
      ) : null }

      
    
    {/* Optional: in case there are other statuses */}
      <p className="text-white">{staff.Name}</p>
    </div>
    
  </div>
))}


                    
              
  
                {/* Bids */}
                {overtime.bids.map((bid) => (

                  // only show bids where Accepted is 0

                  bid.Accepted === 0 &&





                  <div
                    key={bid.id}
                    className="border p-4 rounded-lg shadow-md bg-gray-900 bg-opacity-50 backdrop-blur-sm"
                  >
                    <div className="flex justify-between items-center">
                      <div className="flex-1">
                        {/* Titles */}
                        <p className="font-bold text-white">{bid.Name}</p>
                        <p className="text-lg text-yellow-300">
                          Bid: {bid.Hours} {bid.Hours === 1 ? "Hour" : "Hours"}
                        </p>
                        <p className="text-sm text-white">{formatDate(bid.CreatedAt)}</p>
                        {openModal && (
                                                  <>

                          <select onChange={(event) => setAmendedHours(event.target.value)} 
                          value={amendedHours}
                          
                          className="bg-gray-800 mt-3 border border-gray-600 rounded-md px-3 py-2 text-white">
                            <option value="1">1 Hour</option>
                            <option value="2">2 Hours</option>
                            <option value="3">3 Hours</option>
                          </select>

                          <button type="button" onClick={() => handleSaveAmendment(bid.id, overtime.id)} 
                          data-component="bids-bid-action"
                          data-feature="amend_bid_put"
                          className="bg-emerald-500 ml-3 text-white px-3 py-1 rounded-full hover:bg-green-600 text-xs">
                            Save
                          </button>

</>

                        )}
                      
                      </div>
  
                      {/* Buttons (column aligned and smaller) */}
                      <div className="flex flex-col items-center space-y-2">
                        <button
                          onClick={() => handleAccept(bid.StaffId, overtime.id, bid.Name)}
                          data-component="bids-bid-action"
                          data-time-saved="5"
                          data-feature="accept_bid_put"
                          className="bg-green-500 text-white px-3 py-1 rounded-full hover:bg-green-600 text-xs"
                        >
                          Accept
                        </button>
                        <button
                          onClick={() => handleAmend(bid.id)}
                          className="bg-yellow-500 text-white px-3 py-1 rounded-full hover:bg-yellow-600 text-xs"
                        >
                          Split Hours
                        </button>
                       
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
  
}
